"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeMineApi = exports.storeListApi = exports.storeLibraryPage = exports.storeLibraryImport = exports.storeLeaderOptionsApi = exports.storeGuaranteeOptions = exports.storeGuaranteeGroupUpdate = exports.storeGuaranteeGroupSave = exports.storeGuaranteeGroupList = exports.storeGuaranteeGroupDelete = exports.storeDetailApi = exports.storeDeleteApi = exports.storeCouponUserPage = exports.storeCouponUpdate = exports.storeCouponToggle = exports.storeCouponSave = exports.storeCouponPage = exports.storeCouponDelete = exports.storeCategoryUpdate = exports.storeCategorySave = exports.storeCategoryList = exports.storeCategoryDelete = exports.storeCardVerify = exports.storeCardVerifierSave = exports.storeCardVerifierList = exports.storeCardVerifierDelete = exports.storeCardRecordList = exports.storeCardList = exports.storeBrandUpdate = exports.storeBrandToggle = exports.storeBrandSave = exports.storeBrandOptions = exports.storeBrandList = exports.storeBrandDelete = void 0;
exports.storeMineContractsApi = storeMineContractsApi;
exports.storeStatusApi = exports.storeSaveApi = exports.storeRefundStatusNum = exports.storeRefundRemark = exports.storeRefundRejectReceive = exports.storeRefundReceive = exports.storeRefundPage = exports.storeRefundDetail = exports.storeRefundAudit = exports.storeProductUpdate = exports.storeProductToggle = exports.storeProductSave = exports.storeProductRuleUpdate = exports.storeProductRuleSave = exports.storeProductRulePage = exports.storeProductRuleDetail = exports.storeProductRuleDelete = exports.storeProductReplyVirtual = exports.storeProductReplyPage = exports.storeProductReplyDelete = exports.storeProductReplyComment = exports.storeProductPage = exports.storeProductDetail = exports.storeProductDelete = exports.storeProductCommissionSave = exports.storeProductCommission = exports.storeOrderVerify = exports.storeOrderStatusNum = exports.storeOrderRemark = exports.storeOrderPage = exports.storeOrderDetail = exports.storeOrderDeliveryUpdate = exports.storeOrderDelivery = exports.storeOptionsApi = exports.storeMineSaveApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var prefix = '/admin/distribution/store';

// 淘客运营端门店管理
var storeListApi = exports.storeListApi = function storeListApi(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/list"),
    method: 'get',
    params: params
  });
};
var storeDetailApi = exports.storeDetailApi = function storeDetailApi(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/").concat(id),
    method: 'get'
  });
};
var storeOptionsApi = exports.storeOptionsApi = function storeOptionsApi(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/options"),
    method: 'get',
    params: params
  });
};
var storeLeaderOptionsApi = exports.storeLeaderOptionsApi = function storeLeaderOptionsApi(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/leader/options"),
    method: 'get',
    params: params
  });
};
var storeSaveApi = exports.storeSaveApi = function storeSaveApi(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/save"),
    method: 'post',
    data: data
  });
};
var storeStatusApi = exports.storeStatusApi = function storeStatusApi(id, status) {
  return (0, _request.default)({
    url: "".concat(prefix, "/status/").concat(id),
    method: 'post',
    params: {
      status: status
    }
  });
};
var storeDeleteApi = exports.storeDeleteApi = function storeDeleteApi(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/").concat(id),
    method: 'delete'
  });
};
var storeCategoryList = exports.storeCategoryList = function storeCategoryList(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/category/list"),
    method: 'get',
    params: params
  });
};
var storeCategorySave = exports.storeCategorySave = function storeCategorySave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/category/save"),
    method: 'post',
    data: data
  });
};
var storeCategoryUpdate = exports.storeCategoryUpdate = function storeCategoryUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/category/update"),
    method: 'post',
    data: data
  });
};
var storeCategoryDelete = exports.storeCategoryDelete = function storeCategoryDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/category/delete/").concat(id),
    method: 'post'
  });
};
var storeBrandList = exports.storeBrandList = function storeBrandList(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/list"),
    method: 'get',
    params: params
  });
};
var storeBrandOptions = exports.storeBrandOptions = function storeBrandOptions() {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/cache/list"),
    method: 'get'
  });
};
var storeBrandSave = exports.storeBrandSave = function storeBrandSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/add"),
    method: 'post',
    data: data
  });
};
var storeBrandUpdate = exports.storeBrandUpdate = function storeBrandUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/update"),
    method: 'post',
    data: data
  });
};
var storeBrandToggle = exports.storeBrandToggle = function storeBrandToggle(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/update/show/").concat(id),
    method: 'post'
  });
};
var storeBrandDelete = exports.storeBrandDelete = function storeBrandDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/brand/delete/").concat(id),
    method: 'post'
  });
};
var storeProductPage = exports.storeProductPage = function storeProductPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/page"),
    method: 'get',
    params: params
  });
};
var storeProductDetail = exports.storeProductDetail = function storeProductDetail(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/detail/").concat(id),
    method: 'get'
  });
};
var storeProductSave = exports.storeProductSave = function storeProductSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/save"),
    method: 'post',
    data: data
  });
};
var storeProductUpdate = exports.storeProductUpdate = function storeProductUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/update"),
    method: 'post',
    data: data
  });
};
var storeProductToggle = exports.storeProductToggle = function storeProductToggle(id, status) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/status/").concat(id),
    method: 'post',
    params: {
      status: status
    }
  });
};
var storeProductDelete = exports.storeProductDelete = function storeProductDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/delete/").concat(id),
    method: 'post'
  });
};
var storeProductCommission = exports.storeProductCommission = function storeProductCommission(productId) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/commission/").concat(productId),
    method: 'get'
  });
};
var storeProductCommissionSave = exports.storeProductCommissionSave = function storeProductCommissionSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/commission/save"),
    method: 'post',
    data: data
  });
};
var storeProductRulePage = exports.storeProductRulePage = function storeProductRulePage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/rule/list"),
    method: 'get',
    params: params
  });
};
var storeProductRuleDetail = exports.storeProductRuleDetail = function storeProductRuleDetail(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/rule/info/").concat(id),
    method: 'get'
  });
};
var storeProductRuleSave = exports.storeProductRuleSave = function storeProductRuleSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/rule/save"),
    method: 'post',
    data: data
  });
};
var storeProductRuleUpdate = exports.storeProductRuleUpdate = function storeProductRuleUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/rule/update"),
    method: 'post',
    data: data
  });
};
var storeProductRuleDelete = exports.storeProductRuleDelete = function storeProductRuleDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/rule/delete/").concat(id),
    method: 'post'
  });
};
var storeProductReplyPage = exports.storeProductReplyPage = function storeProductReplyPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/reply/list"),
    method: 'get',
    params: params
  });
};
var storeProductReplyVirtual = exports.storeProductReplyVirtual = function storeProductReplyVirtual(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/reply/virtual"),
    method: 'post',
    data: data
  });
};
var storeProductReplyComment = exports.storeProductReplyComment = function storeProductReplyComment(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/reply/comment"),
    method: 'post',
    data: data
  });
};
var storeProductReplyDelete = exports.storeProductReplyDelete = function storeProductReplyDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/reply/delete/").concat(id),
    method: 'post'
  });
};
var storeGuaranteeOptions = exports.storeGuaranteeOptions = function storeGuaranteeOptions() {
  return (0, _request.default)({
    url: "".concat(prefix, "/guarantee/group/guarantee/list"),
    method: 'get'
  });
};
var storeGuaranteeGroupList = exports.storeGuaranteeGroupList = function storeGuaranteeGroupList() {
  return (0, _request.default)({
    url: "".concat(prefix, "/guarantee/group/list"),
    method: 'get'
  });
};
var storeGuaranteeGroupSave = exports.storeGuaranteeGroupSave = function storeGuaranteeGroupSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/guarantee/group/add"),
    method: 'post',
    data: data
  });
};
var storeGuaranteeGroupUpdate = exports.storeGuaranteeGroupUpdate = function storeGuaranteeGroupUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/guarantee/group/edit"),
    method: 'post',
    data: data
  });
};
var storeGuaranteeGroupDelete = exports.storeGuaranteeGroupDelete = function storeGuaranteeGroupDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/guarantee/group/delete/").concat(id),
    method: 'post'
  });
};
var storeLibraryPage = exports.storeLibraryPage = function storeLibraryPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/library/list"),
    method: 'get',
    params: params
  });
};
var storeLibraryImport = exports.storeLibraryImport = function storeLibraryImport(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/product/library/import"),
    method: 'post',
    data: data
  });
};
var storeOrderPage = exports.storeOrderPage = function storeOrderPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/page"),
    method: 'get',
    params: params
  });
};
var storeOrderDetail = exports.storeOrderDetail = function storeOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/detail/").concat(orderNo),
    method: 'get'
  });
};
var storeOrderStatusNum = exports.storeOrderStatusNum = function storeOrderStatusNum() {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/statusNum"),
    method: 'get'
  });
};
var storeOrderVerify = exports.storeOrderVerify = function storeOrderVerify(verifyCode) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/verify"),
    method: 'post',
    data: {
      verifyCode: verifyCode
    }
  });
};
var storeOrderDelivery = exports.storeOrderDelivery = function storeOrderDelivery(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/delivery"),
    method: 'post',
    data: data
  });
};
var storeOrderDeliveryUpdate = exports.storeOrderDeliveryUpdate = function storeOrderDeliveryUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/delivery/update"),
    method: 'post',
    data: data
  });
};
var storeOrderRemark = exports.storeOrderRemark = function storeOrderRemark(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/order/remark"),
    method: 'post',
    data: data
  });
};
var storeCardVerify = exports.storeCardVerify = function storeCardVerify(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/verify"),
    method: 'post',
    data: data
  });
};
var storeCardList = exports.storeCardList = function storeCardList(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/list"),
    method: 'get',
    params: params
  });
};
var storeCardRecordList = exports.storeCardRecordList = function storeCardRecordList(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/verify/record/list"),
    method: 'get',
    params: params
  });
};
var storeCardVerifierList = exports.storeCardVerifierList = function storeCardVerifierList(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/verifier/list"),
    method: 'get',
    params: params
  });
};
var storeCardVerifierSave = exports.storeCardVerifierSave = function storeCardVerifierSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/verifier/save"),
    method: 'post',
    data: data
  });
};
var storeCardVerifierDelete = exports.storeCardVerifierDelete = function storeCardVerifierDelete(uid) {
  return (0, _request.default)({
    url: "".concat(prefix, "/card/verifier/delete"),
    method: 'post',
    params: {
      uid: uid
    }
  });
};
var storeRefundPage = exports.storeRefundPage = function storeRefundPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/list"),
    method: 'get',
    params: params
  });
};
var storeRefundDetail = exports.storeRefundDetail = function storeRefundDetail(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/detail/").concat(id),
    method: 'get'
  });
};
var storeRefundStatusNum = exports.storeRefundStatusNum = function storeRefundStatusNum() {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/status/num"),
    method: 'get'
  });
};
var storeRefundRemark = exports.storeRefundRemark = function storeRefundRemark(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/mark"),
    method: 'post',
    data: data
  });
};
var storeRefundAudit = exports.storeRefundAudit = function storeRefundAudit(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/audit"),
    method: 'post',
    data: data
  });
};
var storeRefundReceive = exports.storeRefundReceive = function storeRefundReceive(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/receiving"),
    method: 'post',
    data: data
  });
};
var storeRefundRejectReceive = exports.storeRefundRejectReceive = function storeRefundRejectReceive(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/refund/order/receiving/reject"),
    method: 'post',
    data: data
  });
};
var storeCouponPage = exports.storeCouponPage = function storeCouponPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/list"),
    method: 'get',
    params: params
  });
};
var storeCouponSave = exports.storeCouponSave = function storeCouponSave(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/save"),
    method: 'post',
    data: data
  });
};
var storeCouponUpdate = exports.storeCouponUpdate = function storeCouponUpdate(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/update"),
    method: 'post',
    data: data
  });
};
var storeCouponToggle = exports.storeCouponToggle = function storeCouponToggle(id, status) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/status/").concat(id),
    method: 'post',
    params: {
      status: status
    }
  });
};
var storeCouponDelete = exports.storeCouponDelete = function storeCouponDelete(id) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/delete/").concat(id),
    method: 'post'
  });
};
var storeCouponUserPage = exports.storeCouponUserPage = function storeCouponUserPage(params) {
  return (0, _request.default)({
    url: "".concat(prefix, "/coupon/user/list"),
    method: 'get',
    params: params
  });
};

// 门店账号：本店信息（只认登录账号绑定的门店，与平台「门店管理」同一条记录）
var storeMineApi = exports.storeMineApi = function storeMineApi() {
  return (0, _request.default)({
    url: "".concat(prefix, "/mine"),
    method: 'get'
  });
};
var storeMineSaveApi = exports.storeMineSaveApi = function storeMineSaveApi(data) {
  return (0, _request.default)({
    url: "".concat(prefix, "/mine/save"),
    method: 'post',
    data: data
  });
};

/** 本店签约合同：门店负责团长名下已完成的合同 */
function storeMineContractsApi() {
  return (0, _request.default)({
    url: '/admin/distribution/store/mine/contracts',
    method: 'GET'
  });
}